import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination } from "swiper/modules";

const categoryData = [
  {
    name: "Industrial waste",
    imageUrl:
      "https://img.freepik.com/free-photo/factory-producing-co2-pollution_23-2150858399.jpg?t=st=1702476611~exp=1702480211~hmac=cb8e27858d34af01c5ed3e6eb4ba1e98145ec078962e84b6e9cd48cf9b644e6a&w=826",
  },
  {
    name: "Flash Flood",
    imageUrl:
      "https://img.freepik.com/free-photo/aerial-view-flooding-natural-devastation_1268-26907.jpg?t=st=1702476756~exp=1702480356~hmac=0dba6c83cbc14616a15ab3da8bb550a4994dc991cb84a66de3d373eba5c471c5&w=826",
  },
  {
    name: "Algae Growth",
    imageUrl:
      "https://img.freepik.com/free-photo/view-spectacular-nature-landscape_23-2150763710.jpg?ga=GA1.1.804365195.1702476589&semt=ais_ai_generated",
  },
  {
    name: "Garbage Disposal",
    imageUrl:
      "https://img.freepik.com/free-photo/beach-plastic-pollution-photography_1409-5526.jpg?ga=GA1.1.804365195.1702476589&semt=ais_ai_generated",
  },
  {
    name: "Pipeline Damage",
    imageUrl:
      "https://static.vecteezy.com/system/resources/thumbnails/014/253/089/small/valve-on-tube-torn-pipe-valve-boiling-water-pours-from-pipeline-photo.jpg",
  },
  {
    name: "Waterlogging",
    imageUrl:
      "https://akm-img-a-in.tosshub.com/indiatoday/images/story/202007/mumbaeferref_0.jpeg?size=690:388",
  },
];

//!TODO: Replace the dummy data with the actual data from the API
const cityData = [
  {
    name: "Navi Mumbai",
    imageUrl: "https://a.travel-assets.com/findyours-php/viewfinder/images/res40/472000/472947-Utsav-Chowk.jpg",
  },
  {
    name: "Pune",
    imageUrl: "https://mittalbuilders.com/wp-content/uploads/2020/12/Reasons-to-settle-down-in-Pune-1400x700.png",
  },
];

// !TODO: Replace the dummy data with the actual data from the API
const popularityData = [
  {
    name: "Flooding in Mumbai",
    imageUrl: "https://arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/2C2XPXWWHAI6VJ4IFTUGZ2ARFE.jpg",
  },
  {
    name: "Pipleline Damage in Kharghar",
    imageUrl: "https://www.hindustantimes.com/ht-img/img/2023/06/10/1600x900/Navi-Mumbai--India---June-10--2023--Water-getting-_1686424164389.jpg",
  },
];

const dropdownOptions = [
  { value: "categories", label: "Categories" },
  { value: "city", label: "City" },
  { value: "popularity", label: "Popularity" },
];

export default function NearbyCarousel({ nearbyPosts }) {
  const [selectedOption, setSelectedOption] = useState(dropdownOptions[0]);

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(
      dropdownOptions.find((option) => option.value === selectedValue)
    );
  };

  const renderData = () => {
    switch (selectedOption.value) {
      case "categories":
        return categoryData;
      case "city":
        return cityData;
      case "popularity":
        return popularityData;
      default:
        return [];
    }
  };

  return (
    <div>
      <select
        value={selectedOption.value}
        onChange={handleDropdownChange}
        className="w-full text-center border-2  text-black font-semibold rounded-none p-2"
      >
        {dropdownOptions.map((option) => (
          <option
            className="text-black"
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 5,
          slideShadows: false,
        }}
        pagination={false}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
      >
        <div className="">
          {renderData().map((data, index) => (
            <SwiperSlide key={index}>
              <div className="w-full md:w-[50%] justify-center items-center mx-auto">
                <div
                  className="w-full h-[380px] bg-gray-400 rounded-xl"
                  style={{
                    backgroundImage: `url(${data.imageUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <span class="inline-flex items-center px-2 py-1 bg-gray-200 hover:bg-gray-300 rounded-b-xl text-xs font-semibold text-gray-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 32 32"
                    >
                      <circle cx="16" cy="16" r="8" fill="#6c6a6a" />
                    </svg>
                    <span class="ml-1">{data.name}</span>
                  </span>
                </div>
                <div className="text-2xl text-start font-bold text-[#3a3a3a] dark:text-[#FAF7F0]">
                  {data.name}
                </div>
                <div className="text-sm text-start text-[#5a5a5a] dark:text-[#FAF7F0]">
                  Explore the news related to {data.name} in your area.
                </div>
                {/* Additional content based on the selected option */}
                  <div className="my-2 shadow rounded-xl" role="alert">
                    <div class="mx-auto">
                      <div class="bg-white shadow-lg rounded-lg md:p-4 p-6 md:space-y-2 space-y-4">
                        <div class="flex items-center space-x-4">
                          <div class="p-2 bg-purple-200 rounded-full">
                          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="none" stroke="#a91414" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.875 6.27c.7.398 1.13 1.143 1.125 1.948v7.284c0 .809-.443 1.555-1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1-2.184 0l-6.75-4.27A2.225 2.225 0 0 1 3 15.502V8.217c0-.809.443-1.554 1.158-1.947l6.75-3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98zM12 8v4m0 4h.01"/></svg>
                          </div>
                          <div>
                            <div class="text-gray-600 text-sm">
                              Issues Raised in 24hrs
                            </div>
                            <div class="text-gray-900 text-2xl font-semibold">
                              14 
                              <span class="text-green-500 text-sm font-medium flex items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-4 w-4 mr-1"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  stroke-width="2"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M5 15l7-7 7 7"
                                  />
                                </svg>
                                4
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <button className="my-3 p-1 dark:bg-[#161b22] bg-[#cfcfcf] bg-opacity-40 backdrop-filter backdrop-blur-md text-[#161b22] dark:text-[#FAF7F0] rounded-lg w-[100%] hover:bg-opacity-70 shadow-none">
                  <a className="p-2 w-full font-medium text-xs" href="/posts">
                    Explore
                  </a>
                </button>
              </div>
            </SwiperSlide>
          ))}
        </div>
      </Swiper>
    </div>
  );
}
